import { RemoveLicenseBanner } from "./RemoveLicenseBanner";

export default RemoveLicenseBanner;
